import { gql } from "@apollo/client";

const CREATE_RECLAMO = gql`
    mutation createGestionReclamo($input: AddGestionReclamoInput!, $archivos: [ArchivoReclamoInput!] ){
        createGestionReclamo(input: $input, archivos: $archivos) {
            idGestionReclamo
        }
    }
`;

export default CREATE_RECLAMO;

export const adaptAddGestionReclamoInput = (data, isReclamo) => {
  const {
    usuario,
    productos,
    tecnologiasMedicas,
    ...restData
  } = data;
  return {
    ...restData,
    productos: isReclamo ? adaptProductosReclamo(productos) : null,
    tecnologiasMedicas: isReclamo ? adaptProductosReclamo(tecnologiasMedicas) : null,
    tipoReclamo: isReclamo ? 1 : 2
  };
};

export const adaptProductosReclamo = (productos) => {
  return structuredClone(productos)?.map((producto) => {
    const { nombre, __typename, ...restProducto } = producto;
    return restProducto;
  });
};